import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { landingPageEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-landing-page/src/landingPageEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsSchemasRoute } from '@jira/router-routes__assets-app-routes/src/assetsSchemasRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsPageEntryPoint = createChromelessEntryPoint({
	main: landingPageEntryPoint,
});

export const assetsSchemasRouteEntry: Route = createEntry(assetsSchemasRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	entryPoint: () => assetsPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-landing-page',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'assets-app-schemas-page',
	ufoName: 'assets-app-schemas-page',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
